import {
  INSERE_DADOS_OPERADOR,
  ATUALIZA_DADOS_OPERADOR,
  GET_DADOS_RELATORIO_OPERADOR_INDIVIDUAL,
} from './mutation-types'

import relatorioOperadorDetalhadoHttpService from '../_services/relatorioOperadorDetalhadoHttpService'

export default {
  listarLigacoesRelatorio: async ({ commit }, data) => {
    try {
      const response = await relatorioOperadorDetalhadoHttpService.geraRelatorioDetalhadoOperador(data.data, data.id)
      const operador = { operador: data.id, dadosRelatorio: response.data }
      commit(INSERE_DADOS_OPERADOR, operador)
    } catch (e) {
      console.log(e)
    }
  },

  atualizarRelatorioOperadorDetalhado: async ({ commit }, data) => {
    try {
      const response = await relatorioOperadorDetalhadoHttpService.geraRelatorioDetalhadoOperador(
        data.data,
        data.id,
        data.page
      )
      const operador = { operador: data.id, dadosRelatorio: response.data }
      commit(ATUALIZA_DADOS_OPERADOR, operador)
    } catch (e) {
      console.log(e)
    }
  },

  gerarRelatorioOperadorIndividual: async ({ commit }, { form, idOperador }) => {
    try {
      const response = await relatorioOperadorDetalhadoHttpService.geraRelatorioDetalhadoOperador(form, idOperador)
      commit(GET_DADOS_RELATORIO_OPERADOR_INDIVIDUAL, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
